import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

export default function RoutePath({...routeProps}: RouteProps) {
  return <Route {...routeProps} />;
}